<template>
  <div class="sticky-foot-wrapper" :class="{ 'has-sticky-footer': sticky }">
    <header v-if="!!$slots['header']" class="header">
      <slot name="header" />
    </header>
    <div class="scroll-wrapper">
      <section class="content-body" :class="{ 'grow-content': growContent }">
        <slot name="body" />
      </section>
      <footer v-if="!!$slots['footer']" class="footer">
        <slot name="footer" />
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StickyFooter',
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
    growContent: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.sticky-foot-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sticky-foot-wrapper .scroll-wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 350px;
}

.sticky-foot-wrapper section.content-body {
  margin: 0;
}

.sticky-foot-wrapper section.content-body.grow-content {
  flex-grow: 999;
  flex-basis: 1%;
}

/* .sticky-foot-wrapper.has-sticky-footer section { */

.scroll-wrapper footer {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1rem 2rem;
  padding-bottom: 2rem;
  border-top: 1px solid var(--color-border-default);
  background-color: var(--color-background-default);
}

.sticky-foot-wrapper,
.sticky-foot-wrapper.has-sticky-footer .scroll-wrapper {
  overflow: hidden;
}

.sticky-foot-wrapper .scroll-wrapper,
.sticky-foot-wrapper.has-sticky-footer section.content-body {
  overflow: auto;
}

.sticky-foot-wrapper.has-sticky-footer footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
}
</style>
